// packages block
import { Dialog } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useReducer, useState } from "react";
// common block
import "./style.css";
import { preaddStyles } from "./styles";
import { FormButton } from "../form/button";
import { AddBankForm } from "./addBankForm";
import { PreDialogHeader } from "./preDialogHeader";
// constants, theme, utils and api block
import { addBank, editBank } from "../../api/banks";
import { setAlert } from "../../redux/reducers/alert";
import { BLUE_EIGHT, ORANGE_TWO, WHITE } from "../../theme";
import { validateAddBankForm } from "../../util/validation";

export const AddBankDialog = ({
  open,
  handleClose,
  title,
  bankValue,
  bankName,
  successCallback,
  isEditedItem,
}) => {
  const classes = preaddStyles();
  const { t } = useTranslation();
  let local = JSON.parse(localStorage.getItem("notify"));
  local = local || [];
  const [
    {
      bankSwiftCode,
      bankAddress,
      accountNumber,
      accountTitle,
      accountIban,
      bankSwiftCodeError,
      bankAddressError,
      accountNumberError,
      accountTitleError,
      accountIbanError,
    },
    setData,
  ] = useReducer((state, newState) => ({ ...state, ...newState }), {
    bankSwiftCode: "",
    bankAddress: "",
    accountNumber: "",
    accountTitle: "",
    accountIban: "",
    bankSwiftCodeError: false,
    bankAddressError: false,
    accountNumberError: false,
    accountTitleError: false,
    accountIbanError: false,
  });
  const [loading, setLoading] = useState(false);
  const { token } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const handleChange = (prop) => (event) => {

    if (prop == 'bankSwiftCode') {
      if ((event.target.value).length <= 70) {
        setData({
          [prop]: event.target.value,
          bankSwiftCodeError: false,
          bankAddressError: false,
          accountNumberError: false,
          accountTitleError: false,
          accountIbanError: false,
        });
      }
    } else if (prop == 'bankAddress') {

      if ((event.target.value).length <= 20) {
        setData({
          [prop]: event.target.value,
          bankSwiftCodeError: false,
          bankAddressError: false,
          accountNumberError: false,
          accountTitleError: false,
          accountIbanError: false,
        });
      }

    } else if (prop == 'accountNumber') {
      if ((event.target.value).length <= 20) {
        setData({
          [prop]: event.target.value,
          bankSwiftCodeError: false,
          bankAddressError: false,
          accountNumberError: false,
          accountTitleError: false,
          accountIbanError: false,
        });
      }
    } else if (prop == 'accountTitle') {
      if ((event.target.value).length <= 20) {
        setData({
          [prop]: event.target.value,
          bankSwiftCodeError: false,
          bankAddressError: false,
          accountNumberError: false,
          accountTitleError: false,
          accountIbanError: false,
        });
      }
    } else if (prop == 'accountIban') {
      setData({
        [prop]: event.target.value,
        bankSwiftCodeError: false,
        bankAddressError: false,
        accountNumberError: false,
        accountTitleError: false,
        accountIbanError: false,
      });
    }

  };

  useEffect(() => {
    if (isEditedItem) {
      setData({
        bankName: bankName,
        banksLeanId: parseInt(bankValue),
        bankSwiftCode: isEditedItem.bankSwiftCode,
        bankAddress: isEditedItem.bankAddress,
        accountNumber: isEditedItem.accountNumber,
        accountTitle: isEditedItem.accountTitle,
        accountIban: isEditedItem.accountIban,
      });
    }
  }, [isEditedItem]);

  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };

  const showSuccessAlert = (message) => {
    dispatch(
      setAlert({
        severity: "success",
        message,
        show: true,
      })
    );
  };

  const resetData = () => {
    setData({
      bankSwiftCode: "",
      bankAddress: "",
      accountNumber: "",
      accountTitle: "",
      accountIban: "",
    });
  };

  const addBankHandler = async () => {
    const { status, type } = validateAddBankForm(
      bankSwiftCode,
      bankAddress,
      accountNumber,
      accountTitle,
      accountIban,
    );

    if (!status) {
      setData({ [type]: true });
      return;
    }
    try {
      setLoading(true);
      const payload = {
        type: "DESTINATION",
        banksLeanId: parseInt(bankValue),
        bankSwiftCode,
        bankAddress,
        accountNumber,
        accountTitle,
        accountIban,
      };


      const id = await addBank(payload, token);
      if (id) {
        showSuccessAlert(t("text_bank_added_successfully"));
        local.push({
          message: t("text_bank_added_successfully"),
          date: new Date().getTime(),
          newNotification: true,
        });
        localStorage.setItem("notify", JSON.stringify(local));
        resetData();
        successCallback();
      } else {
        showErrorAlert(t("text_error_in_adding_bank_please_try_again"));

      }
    } catch (error) {
    }
  };

  const editBankHandler = async () => {
    const { status, type } = validateAddBankForm(
      bankSwiftCode,
      bankAddress,
      accountNumber,
      accountTitle,
      accountIban,
    );

    if (!status) {
      setData({ [type]: true });
      return;
    }
    try {
      setLoading(true);
      const payload = {
        type: "DESTINATION",
        banksLeanId: parseInt(bankValue),
        bankSwiftCode,
        bankAddress,
        accountNumber,
        accountTitle,
        accountIban,
      };

      const response = await editBank(payload, isEditedItem.id, token);
      if (response?.status) {
        showSuccessAlert(t("text_bank_updated_successfully"));
        local.push({
          message: t("text_bank_updated_successfully"),
          date: new Date().getTime(),
          newNotification: true,
        });
        localStorage.setItem("notify", JSON.stringify(local));
        successCallback();
        resetData();
      } else {
        showErrorAlert(t("text_error_in_updating_bank_please_try_again"));
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      showErrorAlert(
        err.message || t("text_error_in_updating_bank_please_try_again")
      );
    }
  };

  const close = () => {
    resetData();
    handleClose();
  };

  return (
    <Dialog
      className={classes.root}
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <div className={classes.mainContainer}>
        <PreDialogHeader backbut={true} title={title} handleClose={handleClose} />

        <div className={classes.dropContainer}>
          <AddBankForm
            bankName={bankName}
            bankSwiftCode={bankSwiftCode}
            bankAddress={bankAddress}
            accountNumber={accountNumber}
            accountTitle={accountTitle}
            accountIban={accountIban}
            bankSwiftCodeError={bankSwiftCodeError}
            bankAddressError={bankAddressError}
            accountNumberError={accountNumberError}
            accountTitleError={accountTitleError}
            accountIbanError={accountIbanError}
            handleChange={handleChange}
          />
        </div>

        <div className={classes.addBankdialogFooter}>
          <div className={classes.footerButton}>
            <FormButton
              title={t("text_cancel")}
              borderColor={ORANGE_TWO}
              titleColor={WHITE}
              hoverTitleColor={ORANGE_TWO}
              hoverBorderColor={ORANGE_TWO}
              backgroundColor={ORANGE_TWO}
              hoverBackgroundColor={WHITE}
              onClickHandler={close}
              height={40}
              width={"10vw"}
              borderTopRightRadius={15}
              borderTopLeftRadius={15}
              borderBottomLeftRadius={15}
              borderBottomRightRadius={15}
              style={{ textTransform: "none", fontSize: "0.8vw", fontWeight: "700" }}
            />
          </div>

          <div className={classes.footerButton}>
            <FormButton
              loading={loading}
              borderColor={BLUE_EIGHT}
              titleColor={BLUE_EIGHT}
              hoverTitleColor={WHITE}
              hoverBorderColor={BLUE_EIGHT}
              backgroundColor={WHITE}
              hoverBackgroundColor={BLUE_EIGHT}
              style={{ textTransform: "none", fontSize: "0.8vw", fontWeight: "700", padding: 0 }}
              title={t("text_continue")}
              onClickHandler={
                isEditedItem ? editBankHandler : addBankHandler
              }
              height={40}
              width={"10vw"}
              borderTopRightRadius={15}
              borderTopLeftRadius={15}
              borderBottomLeftRadius={15}
              borderBottomRightRadius={15}
            />
          </div>
        </div>
      </div>
    </Dialog>
  );
};
